import { Box, Flex, HStack, Image } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { Heading } from 'ui-components';
import { FakeDoorContext } from '~/components/FakeDoorProvider/context';
import { useGetAgency } from '~/hooks/api/agencies/get';
import { useGetMediaKit } from '~/hooks/api/media-kits/get';

import { ContactBtn } from './ContactBtn';

export const TopBar = () => {
  const router = useRouter();
  const id = router.query.id as string;
  const mediaKit = useGetMediaKit({ id });
  const agency = useGetAgency(mediaKit.data?.agency_id || '');
  const fakeDoorCtx = useContext(FakeDoorContext);

  return (
    <Flex
      paddingY={{
        base: 8,
        lg: 0,
      }}
      paddingX={{
        base: 6,
        lg: 0,
      }}
      paddingBottom={{
        base: 3,
        lg: 10,
      }}
      justifyContent="space-between"
      alignItems="center"
      wrap="wrap"
      overflow="hidden"
      gap={4}
    >
      <Flex
        justifyContent="center"
        flex={{
          base: 1,
          md: 'none',
        }}
      >
        <Image height="3rem" src={agency.data?.agencyLogo} />
      </Flex>
      <HStack
        alignItems="center"
        justifyContent="space-between"
        overflow="hidden"
        flex={{
          base: 'none',
          md: 1,
        }}
        width="100%"
      >
        <Box flex="1" minWidth={0}>
          <Heading
            size="md"
            sx={{
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
            color="var(--media-kit-text-base)"
          >
            {mediaKit.data?.name}
          </Heading>
        </Box>

        {fakeDoorCtx?.action && (
          <fakeDoorCtx.action
            variant="ghost"
            className="!bg-[#ffffff50] px-6"
          />
        )}

        <ContactBtn email={mediaKit.data?.contact.manager_email || ''} />
      </HStack>
    </Flex>
  );
};
